import type { TripPlannerChat } from 'tripPlanner/api/types'
import type { BasicTrip } from 'tripPlanner/types/common'
import { CHAT_TRIP_PLANNER_PATH } from 'tripPlanner/config'
import { getTimestampSortValue } from 'tripPlanner/utils/chatTimestamps'
import { getDestinationsLabel } from 'tripPlanner/utils/places'
import { getTripURL } from 'tripPlanner/utils'
import { buildRecentAiChatItem, type RecentAiChatItem } from 'tripPlanner/utils/recentAiChatItem'

interface RecentClassicTripItem {
  type: 'classicTrip'
  id: string
  title: string
  subtitle?: string
  updatedAt: string
  sortTimestamp: number
}

export type RecentChatItem = RecentAiChatItem | RecentClassicTripItem

function getClassicTripSubtitle(trip: BasicTrip): string | undefined {
  if (!trip.destinationsGeo || trip.destinationsGeo.length === 0) {
    return undefined
  }

  return getDestinationsLabel(trip.destinationsGeo, 1)
}

export function buildRecentChatItems(
  chats: Array<TripPlannerChat>,
  trips: Array<BasicTrip>,
): Array<RecentChatItem> {
  const aiChatItems: Array<RecentChatItem> = chats.map(buildRecentAiChatItem)

  const classicTripItems: Array<RecentChatItem> = trips.map((trip) => {
    const updatedAt = trip.updatedAt.isValid() ? trip.updatedAt.toISOString() : ''
    return {
      type: 'classicTrip',
      id: trip.id,
      title: trip.name,
      subtitle: getClassicTripSubtitle(trip),
      updatedAt,
      sortTimestamp: getTimestampSortValue(trip.updatedAt),
    }
  })

  return [...aiChatItems, ...classicTripItems].sort((a, b) => b.sortTimestamp - a.sortTimestamp)
}

export function getRecentChatItemUrl(item: RecentChatItem): string {
  if (item.type === 'aiChat') {
    return `${CHAT_TRIP_PLANNER_PATH}/${item.id}`
  }

  return getTripURL(item.id)
}
